var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTicketBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 11.8571L0.5 10.1113L1.16649 10.1113L1.16649 9.38911L0.5 9.38911L0.499999 1.14286C0.499999 0.511677 1.01168 -2.23661e-08 1.64286 -4.99561e-08L3.16666 -1.16563e-07L3.16666 0.000135305C3.16666 0.79788 3.76361 1.44458 4.49999 1.44458C5.23637 1.44458 5.83333 0.79788 5.83333 0.000135189L5.83333 -2.33127e-07L7.35714 -2.99735e-07C7.98832 -3.27325e-07 8.5 0.511676 8.5 1.14286L8.5 9.38911L7.83338 9.38911L7.83338 10.1113L8.5 10.1113L8.5 11.8571C8.5 12.4883 7.98832 13 7.35714 13L5.83333 13C5.83326 12.2023 5.23633 11.5557 4.49999 11.5557C3.76366 11.5557 3.16673 12.2023 3.16666 13L1.64286 13C1.01168 13 0.5 12.4883 0.5 11.8571ZM1.83321 9.38911L1.83321 10.1113L3.16654 10.1113L3.16654 9.38911L1.83321 9.38911ZM3.83327 9.38911L3.83327 10.1113L5.1666 10.1113L5.1666 9.38911L3.83327 9.38911ZM5.83332 10.1113L5.83332 9.38911L7.16665 9.38911L7.16665 10.1113L5.83332 10.1113Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicketBlack);
export default __webpack_public_path__ + "static/media/icon-ticket-black.04ceb2650985bab5ba3b7a0bbc0332be.svg";
export { ForwardRef as ReactComponent };